import { YesNoEnum } from '@shared/model/yes-no.model';
import { OfficeFieldWebInputType, OfficeFieldsValuesObj } from './office-data.model';

export enum ModalFormTypeEnum {
  Form,
  Confirmation,
}
export type ModalFormType = `${ModalFormTypeEnum} ` extends `${infer U extends number}` ? U : never;

//TODO: If it possible change metadata as vista field
export interface IModalFormItem<T = unknown> {
  IsReadOnly: boolean;
  Label: string;
  Required: YesNoEnum;
  Seq: number;
  WebInputType: OfficeFieldWebInputType;
  formValue: T;
}

export interface IBaseEventArgs {
  resultMessage?: string;
  error?: string;
  isCanceled?: boolean;
}

interface IBaseModalFormMetadata extends IBaseEventArgs {
  title: string;
  applyFields: OfficeFieldsValuesObj;
  nextStep?: string;
  modalType: ModalFormType;
}

export interface FormModalMetadata extends IBaseModalFormMetadata {
  modalType: ModalFormTypeEnum.Form;
  items: IModalFormItem[];
}

export interface ConfirmationModalMetadata extends IBaseModalFormMetadata {
  modalType: ModalFormTypeEnum.Confirmation;
  confirmationPrompt: string;
}

export type ModalFormMetadata = FormModalMetadata | ConfirmationModalMetadata;
export type BaseEventArgs = IBaseEventArgs;
